import { isOfType } from '../../../utils/isOfType';
import { DiseaseType } from '../../../interfaces/common/common';

export const isOfTypeDiseaseType = (value: string): value is DiseaseType => {
  return isOfType<DiseaseType>(value, ['acromegaly' , 'cushing']);
}
